import React from 'react';

export interface MobileCardRowProps<T> {
  row: T;
  columns: Array<{
    key: string;
    label: string;
    width?: string;
  }>;
  renderCell?: (row: T, columnKey: string, rowIdx?: number, colIdx?: number) => React.ReactNode;
  rowIdx: number;
  isTotalsRow?: boolean;
  className?: string;
}

/**
 * Mobile card layout for table rows - renders each row as a card with stacked labels/values
 * Used for screens ≤640px to avoid horizontal scrolling
 */
const MobileCardRow = <T extends { id?: string | number }>({
  row,
  columns,
  renderCell,
  rowIdx,
  isTotalsRow = false,
  className = ''
}: MobileCardRowProps<T>) => {
  return (
    <div 
      className={`theme-surface rounded-lg border theme-border p-4 mb-3 shadow-sm ${isTotalsRow ? 'bg-[var(--bg-muted)] border-2' : ''} ${className}`}
      style={{ minHeight: '44px' }} // Ensure minimum tap target
    >
      <div className="space-y-3">
        {columns.map((column, colIdx) => {
          const cellContent = renderCell ? renderCell(row, column.key, rowIdx, colIdx) : (row as Record<string, unknown>)[column.key];
          
          return (
            <div 
              key={column.key} 
              className="flex flex-col space-y-1"
              style={{ minHeight: '44px' }} // Ensure minimum tap target for each field
            >
              <div className="text-xs font-semibold theme-text-muted uppercase tracking-wider">
                {column.label}
              </div>
              <div className="theme-text text-sm">
                {cellContent as React.ReactNode}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MobileCardRow;

